import React, { FC } from 'react';
import styled, { ThemeProvider } from 'styled-components';

import { ButtonGroup } from '../StateManagementButton/ButtonGroup';
import { FULL_VH } from 'components/Common';
import theme from 'themes';
import { Button, StringOrReactElement } from '../StateManagementButton/types';

const StyledContainer = styled.div`
  color: #000;
  background: white;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 65537;
  ${({ theme }) => theme.Modal}
`;

const HeightContainer = styled.div`
  position: relative;
  height: 100%;
  max-height: ${0.9 * FULL_VH}px;
  display: flex;
  flex-direction: column;
`;

const sectionBorder = '1px solid #edecf2;';

const Above = styled.div`
  text-align: center;
  font-size: 16px;
  line-height: 1.5;
  margin: 25px 30px;
`;

const AboveString = styled.div`
  margin-top: 20px;
`;

// Center and CenterBox are a trick to
// both constrain the center area in the context of
// the HeightContainer flexbox and allow it to grow up to
// a maximum size. At this point it will scroll.
const Center = styled.div`
  flex-shrink: 1;
  overflow-y: auto;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar:vertical {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
    border: none;
    background-color: rgba(0, 0, 0, 0.25);
  }
  &::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 2px;
  }
`;

const CenterBox = styled.div`
  display: flex;
  min-height: min-content;
`;

const Below = styled.div`
  padding: 15px;
`;

const Title = styled.div`
  color: #030303;
  font: 18px ${({ theme }) => theme.fontSemibold};
  line-height: 24px;
`;

interface ContentProps {
  contentAbove: StringOrReactElement;
  contentCenter: StringOrReactElement;
  buttons: Button[];
  title: string;
}

export const Content: FC<ContentProps> = ({ buttons, contentAbove, contentCenter, title }) => {
  let above, center;
  if (contentAbove) {
    above =
      typeof contentAbove === 'string' ? (
        <AboveString>{contentAbove}</AboveString>
      ) : (
        contentAbove
      );
  }
  if (contentCenter) {
    center = (
      <Center>
        <CenterBox>{contentCenter}</CenterBox>
      </Center>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <StyledContainer>
        <HeightContainer>
          <Above>
            <Title>{title}</Title>
            {above}
          </Above>
          {center}
          <Below>
            <ButtonGroup buttons={buttons} />
          </Below>
        </HeightContainer>
      </StyledContainer>
    </ThemeProvider>
  );
};
